// extracted by mini-css-extract-plugin
module.exports = {"container":"InfiniteScroll_container__1TisJ","loading":"InfiniteScroll_loading__1qxrH","loading-text":"InfiniteScroll_loading-text__aPit7"};